import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrash } from '@fortawesome/free-solid-svg-icons';

interface AdminControlsProps {
    onEdit: () => void;
    onDelete: () => void;
}

export const AdminControls: React.FC<AdminControlsProps> = ({ onEdit, onDelete }) => (
    <div className='admin-controls'>
        <button
            type='button'
            className='admin-icon delete-icon'
            onClick={onDelete}
            aria-label='Delete coffee entry'
        >
            <FontAwesomeIcon icon={faTrash} />
        </button>
        <button
            type='button'
            className='admin-icon'
            onClick={onEdit}
            aria-label='Edit coffee entry'
        >
            <FontAwesomeIcon icon={faPencilAlt} />
        </button>
    </div>
);
